import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';
import dayjs from 'dayjs';

import {
    datasetLoadingSelector,
    entitySelector,
    createFetchPaginatedDataset
} from '@libs/datasets';

import { AppliedLeavesShared } from 'common/components/shared/LeaveComponents';
import { EMPLOYEE_APPLIED_LEAVES } from '../redux.datasets';
import { DOMAIN_NAME, ROWS_PER_PAGE } from '../common';
import CancelLeaveForm from './CancelLeaveForm';
import LeaveDetails from './LeaveDetails';
import { TABLE_DATA, DETAILS_DATA } from './common';

const propTypes = {};

const defaultProps = {
    entity: EMPLOYEE_APPLIED_LEAVES,
    domain: DOMAIN_NAME,
    loading: true
};

const totalRowsSelector = createCachedSelector(entitySelector, (resp) =>
    resp.total ? parseInt(resp.total) : 0
)((domain, entity) => `@data-${domain}-${entity}`);

const dataSelector = createSelector(
    (state) => entitySelector(state, DOMAIN_NAME, EMPLOYEE_APPLIED_LEAVES),
    (resp) => (resp && resp.data ? resp.data : [])
);

const mapState = (state, { domain, entity }) => ({
    data: dataSelector(state, domain, entity),
    loading: datasetLoadingSelector(state, domain, entity),
    totalRows: totalRowsSelector(state, domain, entity)
});

const mapDispatch = (dispatch, { entity }) => ({
    fetchDataset: ({
        offset = '',
        limit = ROWS_PER_PAGE,
        shouldAppend = false,
        from,
        to
    }) =>
        dispatch(
            createFetchPaginatedDataset({
                entity: entity,
                domain: DOMAIN_NAME
            })({
                limit,
                offset,
                shouldAppend,
                'sort-descending': true,
                from,
                to
            })
        )
});

const AppliedLeaves = connect(
    mapState,
    mapDispatch
)(({ fetchDataset, data, totalRows = 0, year, ...props }) => {

    const getYearDateRange = React.useCallback((selectedYear) => {
        const startDate = dayjs(`${selectedYear}-01-01`).startOf('year').toISOString();
        const endDate = dayjs(`${selectedYear}-12-31`).endOf('year').toISOString();
        return { startDate, endDate };
    }, []);

    return (
        <AppliedLeavesShared
            title="All Leaves"
            tableData={TABLE_DATA}
            detailsData={DETAILS_DATA}
            fetchDataset={fetchDataset}
            data={data}
            totalRows={totalRows}
            year={year}
            showCancelAction={true}
            paginationConfig={{
                name: 'appliedLeaves',
                rowsPerPage: ROWS_PER_PAGE
            }}
            LeaveDetailsComponent={LeaveDetails}
            CancelLeaveComponent={CancelLeaveForm}
            getYearDateRange={getYearDateRange}
            usePaginationVariant={true}
        />
    );
});

AppliedLeaves.propTypes = propTypes;
AppliedLeaves.defaultProps = defaultProps;

export default AppliedLeaves;
